// Styles
import styles from './ConditionalFiltersList.module.css';

/**
 * ConditionalFiltersList
 * @param {object} props
 * @param {Array<ApiManagerGlobalFiltersCreateValue & { _id?: string }>} props.fields
 * @param {(field: ApiManagerGlobalFiltersCreateValue, index: number) => import('react').ReactNode} props.children
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
function ConditionalFiltersList({ fields, children, className = '' }) {
  return (
    <div className={`${styles.list} ${className}`}>
      {fields?.map((field, index) => (
        // eslint-disable-next-line no-underscore-dangle
        <div key={field?._id || field?.id} className={styles.item}>
          {children(field, index)}
        </div>
      ))}
    </div>
  );
}

export default ConditionalFiltersList;
